import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ number, label, testid }) => (
  <div className="flex items-center gap-4" data-testid={testid}>
    <span className="font-mono text-xs tracking-[0.3em] text-gold">{number}</span>
    <span className="h-px w-12 bg-gold/40" />
    <span className="font-mono text-xs uppercase tracking-[0.3em] text-slate-400">
      {label}
    </span>
  </div>
);
